import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MessagingService } from '../stripe/messaging.service';

@Component({
    selector: 'convfact-contact-sales-dialog',
    templateUrl: './contact-sales-dialog.component.html',
    styleUrls: ['./contact-sales-dialog.component.css'],
    standalone: false
})
export class ContactSalesDialogComponent {

  contact = {
    name: '',
    company: '',
    phone: '',
    email: ''
  };

  isSending = false;
  result: 'ok' | 'error' | null = null;

  constructor(
    public dialogRef: MatDialogRef<ContactSalesDialogComponent>,
    private messagingService: MessagingService
  ) { }

  sendContact(): void {
    if (!this.contact.name || !this.contact.email) {
      return;
    }
    this.isSending = true;
    this.messagingService.send(this.contact, 'enterprise').then((response) => {
      this.isSending = false;
      this.result = response.error ? 'error' : 'ok';
    }).catch(() => {
      this.isSending = false;
      this.result = 'error';
    });
  }

  closeDialog(): void {
    this.dialogRef.close();
  }
}
